<template>
  <AuthLayout :mode="mode">
    <Section
      heading="Ask the Pros"
      description="This is a member-only service where you can get free advice from experts in various fields. If you need more help, they will be happy to offer their services directly."
      :mode="mode"
    />
    <div class="grid gap-6 sm:gap-4">
      <CollapsibleCard :mode="mode" title="Accounting">
        <template #body>
          <div
            class="grid gap-2 border-b pb-6 sm:pb-4"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h5 class="font-semibold">LLP Public Accountants</h5>
            <ul
              class="grid list-disc gap-2 pl-4"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              <li class="leading-none">Leaf</li>
              <li class="leading-none">Saltzman</li>
              <li class="leading-none">Manganelli</li>
              <li class="leading-none">Pfeil & Tendler</li>
            </ul>
          </div>
          <div
            class="grid gap-2 border-b pb-6 sm:pb-4"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h5 class="font-semibold">
              310 Passaic Avenue Fairfield, New Jersey 07004
            </h5>
            <ul
              class="flex list-disc flex-col gap-2.5 pl-4"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Website:</span>
                  <a
                    href="http://www.njcpafirm.com/"
                    class="hover:text-primary-100 hover:underline"
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >www.njcpafirm.com</a
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Phone:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(800) 533-3927</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Fax:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(973) 808-9630</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">New Jersey:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(973) 808-9500</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">New York:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(212) 677-5700</span
                  >
                </div>
              </li>
            </ul>
          </div>
          <div class="grid gap-2">
            <h5 class="font-semibold">
              Looking for an Accounting Firm that Knows our Business? A firm
              that Will
            </h5>
            <ul
              class="flex list-disc flex-col gap-2.5 pl-4 text-black-60 sm:gap-1.5"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              <li class="leading-none sm:leading-[1.5]">
                <div class="flex items-center gap-1">
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >Provide the finest auditing, accounting, tax and management
                    advisory services possible.</span
                  >
                </div>
              </li>
              <li class="leading-none sm:leading-[1.5]">
                <div class="flex items-center gap-1">
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >Endeavor to help each client to reach their maximum
                    potential.</span
                  >
                </div>
              </li>
              <li class="leading-none sm:leading-[1.5]">
                <div class="flex items-center gap-1">
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >Maintain a personal relationship with clients that are the
                    foundation of our practice.</span
                  >
                </div>
              </li>
            </ul>
            <div class="mt-2">
              <h5 class="font-semibold">
                Direct your Accounting Questions to Donald Saltzman
              </h5>
              <p
                class="mt-2 leading-none"
                :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
              >
                He knows our business.
                <a
                  href="mailto:donaldjs@njcpafirm.com"
                  class="text-primary-100 underline"
                  >donaldjs@njcpafirm.com</a
                >
              </p>
            </div>
          </div>
        </template>
      </CollapsibleCard>
      <CollapsibleCard :mode="mode" title="Equipment residuals and appraisals">
        <template #body>
          <div
            class="grid gap-2 border-b pb-6 sm:pb-4"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h5 class="font-semibold">
              DMC Consulting Group 61 WentworthNewport Beach, CA 92660-9019
            </h5>
            <ul
              class="grid list-disc gap-2 pl-4"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Phone:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(949) 737-7780</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Fax:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(949) 737-7784</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Email:</span>
                  <a
                    href="mailto:pdaley@dmcvaluations.com"
                    class="hover:text-primary-100 hover:underline"
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >pdaley@dmcvaluations.com</a
                  >
                </div>
              </li>
            </ul>
          </div>
          <div class="grid gap-2">
            <p :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']">
              Looking for information on equipment residual values or an
              appraisal by an Accredited Senior Appraisal Daley Marketing offers
              a host of services including some great subscription offerings
              that target the technology industry.
            </p>
            <p :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']">
              Contact Pete Daley with your questions at.
              <a href="#" class="text-primary-100 underline"
                >pdaley@dmcvaluations.com</a
              >
            </p>
          </div>
        </template>
      </CollapsibleCard>
      <CollapsibleCard :mode="mode" title="Legal">
        <template #body>
          <div
            class="grid gap-2 border-b pb-6 sm:pb-4"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h5 class="font-semibold">
              Arthur P. Freierman, Esq Attorney at Law
            </h5>
            <ul
              class="grid list-disc gap-2 pl-4"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Phone:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >212-332-1616</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Email:</span>
                  <a
                    href="mailto:apf@southbridge.com"
                    class="hover:text-primary-100 hover:underline"
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >apf@southbridge.com</a
                  >
                </div>
              </li>
            </ul>
          </div>
          <div
            class="grid gap-2 border-b pb-6 sm:pb-4"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h5 class="font-semibold">
              Not only is he the Association Legal Counsel, but Arthur Freierman
              has Helped many of our Members in Issues such as
            </h5>
            <ul
              class="grid list-disc gap-2 pl-4"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              <li class="leading-none">merger</li>
              <li class="leading-none">acquisitions</li>
              <li class="leading-none">personel issues</li>
              <li class="leading-none">
                contracts and and general business issues
              </li>
            </ul>
          </div>
          <div>
            <p :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']">
              Arthur Freierman is the person to contact when you whether you
              have a general business question or a legal one requiring
              expertise in the technology resale business.
              <a
                href="mailto:apf@southbridge.com"
                class="text-primary-100 underline"
                >apf@southbridge.com</a
              >
            </p>
          </div>
        </template>
      </CollapsibleCard>
      <CollapsibleCard
        :mode="mode"
        title="Merger/Acquisition/Exit strategy consulting"
      >
        <template #body>
          <div
            class="grid gap-2 border-b pb-6 sm:pb-4"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h5 class="font-semibold">COMPUTER PRODUCTS MARKETING, INC.</h5>
            <div class="mb-1">
              <p
                :class="[mode === 'dark' ? 'text-white-100' : 'text-black-100']"
              >
                P. O. Box 6960 <br />
                Laguna Niguel, CA 92607-6960
              </p>
            </div>
            <ul
              class="grid list-disc gap-2 pl-4"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Office:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(949) 597-8026</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Fax:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(949) 597-8027</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Cell:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(310) 801-7885</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Wbsite:</span>
                  <a
                    href="mailto:CPMConsult@aol.com"
                    class="hover:text-primary-100 hover:underline"
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >CPMConsult@aol.com</a
                  >
                </div>
              </li>
            </ul>
          </div>
          <div class="grid gap-2">
            <p :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']">
              Tony Coppola specializes in advising owners of tech firms looking
              to grow or exit through mergers and acquisitions. Contact Tony at.
              <a
                href="mailto:CPMConsult@aol.com"
                class="text-primary-100 underline"
                >CPMConsult@aol.com</a
              >
            </p>
          </div>
        </template>
      </CollapsibleCard>
      <CollapsibleCard
        :mode="mode"
        title="Telemarketing and lead qualifications"
      >
        <template #body>
          <div
            class="grid gap-2 border-b pb-6 sm:pb-4"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h5 class="font-semibold">DeRosa Communications</h5>
            <div class="mb-1">
              <p
                :class="[mode === 'dark' ? 'text-white-100' : 'text-black-100']"
              >
                4040 Civic Center Drive, <br />
                Suite 200 San Rafael, CA 94903
              </p>
            </div>
            <ul
              class="grid list-disc gap-2 pl-4"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Email:</span>
                  <a
                    href="mailto:jack.derosa@derosa.com"
                    class="hover:text-primary-100 hover:underline"
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >jack.derosa@derosa.com</a
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Wbsite:</span>
                  <a
                    href="http://www.derosa.com/"
                    class="hover:text-primary-100 hover:underline"
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >www.derosa.com</a
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Phone:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(800) 640-6409</span
                  >
                </div>
              </li>
              <li class="leading-none">
                <div class="flex items-center gap-1">
                  <span class="block min-w-[85px]">Outside:</span>
                  <span
                    :class="[
                      mode === 'dark' ? 'text-white-100' : 'text-black-100',
                    ]"
                    >(415) 453-9595</span
                  >
                </div>
              </li>
            </ul>
          </div>
          <div class="grid gap-2">
            <p :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']">
              No one knows telemarketing and lead qualifications like Jack
              Derosa. Couple that with the fact that Jack used to be a
              technology dealer and you have an unbeatable resource.
            </p>
            <p :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']">
              Have a telemarketing question? Contact Jack Derosa at.
              <a
                href="mailto:jack.derosa@derosa.com"
                class="text-primary-100 underline"
                >jack.derosa@derosa.com</a
              >
            </p>
          </div>
        </template>
      </CollapsibleCard>
      <CollapsibleCard
        :mode="mode"
        title="Web-marketing/Web-Branding/Search engine maximization"
      >
        <template #body>
          <div
            class="grid gap-2 border-b pb-6 sm:pb-4"
            :class="[
              mode === 'dark' ? 'border-dark-border' : 'border-border-10',
            ]"
          >
            <h5 class="font-semibold">
              Companies found in Violation or not Repsonsive* <br />
              to ITAD Association Ethics Complaints Can be Found here.
            </h5>
          </div>
          <div class="grid gap-2">
            <h5 class="font-semibold">Ethics Files</h5>
            <p
              class="mb-1"
              :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-80']"
            >
              If you are looking for an ethics violator/non-responder we suggest
              you search this folder by name, company, phone number or address.
              Sometimes the company you are looking for changes one of these
              data points to hide their identity.
            </p>
            <Notes :list="notesList" />
          </div>
        </template>
      </CollapsibleCard>
    </div>
  </AuthLayout>
</template>

<script>
import Section from "@C/Common/Section.vue";
import Notes from "@C/Common/Notes.vue";
import CollapsibleCard from "@C/Common/CollapsibleCard.vue";
import AuthLayout from "@A/AuthLayout.vue";

export default {
  name: "AskThePros",
  components: {
    AuthLayout,
    Section,
    Notes,
    CollapsibleCard,
  },
  props: {
    mode: String,
  },
  data() {
    return {
      notesList: [
        "Please note ONLY members of the ITAD Association and eTN (equipment trading network) are required to respond to Ethics complaints. We strongly recommend only dealing with ITAD Association member companies to assure you that you are dealing with a company that honors our code of ethics.",
      ],
    };
  },
};
</script>
